export const PRESETS = [
  { key: "7d", label: "7 Days" },
  { key: "30d", label: "30 Days" },
  { key: "90d", label: "90 Days" },
  { key: "thisQuarter", label: "This Quarter" },
  { key: "lastQuarter", label: "Last Quarter" },
  { key: "custom", label: "Custom" },
];

function startOfQuarter(date) {
  const q = Math.floor(date.getMonth() / 3);
  return new Date(date.getFullYear(), q * 3, 1);
}

function endOfQuarter(date) {
  const start = startOfQuarter(date);
  return new Date(start.getFullYear(), start.getMonth() + 3, 0, 23, 59, 59, 999);
}

/**
 * Resolve a preset key to a concrete { start, end } Date range.
 * "custom" is not handled here — callers supply their own dates for it.
 */
export function getPresetRange(key) {
  const now = new Date();

  switch (key) {
    case "7d":
      return { start: new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000), end: now };
    case "30d":
      return { start: new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000), end: now };
    case "90d":
      return { start: new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000), end: now };
    case "thisQuarter":
      return { start: startOfQuarter(now), end: now };
    case "lastQuarter": {
      const lastQuarterAnchor = new Date(startOfQuarter(now).getTime() - 1);
      return { start: startOfQuarter(lastQuarterAnchor), end: endOfQuarter(lastQuarterAnchor) };
    }
    default:
      return { start: new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000), end: now };
  }
}